(function(){
  'use strict';
  var URL='https://cdn.shopify.com/s/files/1/0289/3555/3099/articles/https_3A_2F_2Fsubstack-post-media.s3.amazonaws.com_2Fpublic_2Fimages_2F6b958170-0246-4ba2-b00a-d361411760a2_3360x2240_340b41ad-1dd8-411e-9f7b-28123828d8f7.jpg?v=1792215887';
  function apply(){
    var media=document.querySelector('.mrak-journal-index .mj-latest-media');
    if(!media) return false;
    if(media.querySelector('img')) return true;
    var img=document.createElement('img');
    img.src=URL+'&width=1400';
    img.srcset=URL+'&width=480 480w, '+URL+'&width=720 720w, '+URL+'&width=960 960w, '+URL+'&width=1400 1400w';
    img.sizes='(min-width: 990px) 62vw, 100vw';
    img.alt='Tai・lue Round Table';
    img.loading='eager';
    img.decoding='async';
    media.innerHTML='';
    media.appendChild(img);
    return true;
  }
  function run(){
    if(apply()) return;
    var tries=0;
    var timer=setInterval(function(){
      tries++;
      if(apply()||tries>20) clearInterval(timer);
    },150);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
  window.addEventListener('load',apply,{once:true});
})();
